import React from 'react'
import * as Yup from 'yup'
import { Formik } from 'formik'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Envelope } from '@phosphor-icons/react'

import TextField from '../FormLegacy/FormFieldsV2/TextField'
import api from '../../api/api'
import { EMAIL_REGEX } from '../../helpers/constants'

import { getAuthConfig } from './utils'

const EmailCheckup = ({ setStep, setEmail }) => {
  const { t } = useTranslation(['auth'])
  const [isNotFound, setIsNotFound] = React.useState(false)
  const [isDeactivated, setIsDeactivated] = React.useState(false)
  const [isNotVerified, setIsNotVerified] = React.useState(false)

  const authConfig = getAuthConfig(window.location.hostname)

  const validationSchema = Yup.object().shape({
    email: Yup.string().matches(EMAIL_REGEX, t('auth:emailCheckup.invalidFormat')),
  })

  const onSubmit = async (values) => {
    setIsNotFound(false)
    setIsDeactivated(false)
    setIsNotVerified(false)

    await api
      .verifyAuthEmail(values.email)
      .then((res) => {
        setEmail(values.email)
        const { isActive, isEmailVerified, isDeactivated, isNotFound } = res.data
        if (isNotFound) {
          setIsNotFound(true)
          return
        }
        if (isDeactivated) {
          setIsDeactivated(true)
          return
        }
        if (!isEmailVerified || !isActive) {
          setIsNotVerified(true)
          return
        }
        if (isActive) {
          setStep('login')
        }
      })
      .catch((err) => {
        console.error(err)
      })
  }

  return (
    <Formik
      initialValues={{
        email: '',
      }}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {({ handleSubmit, values, handleChange, touched, errors, setFieldTouched }) => (
        <form onSubmit={handleSubmit} className="auth__form">
          <h1>{t(authConfig.header)}</h1>
          <p className="auth__step-description">{t('auth:emailCheckup.description')}</p>
          <TextField
            type="text"
            name="email"
            label={t('auth:shared.email')}
            placeholder={t('auth:shared.email')}
            value={values.email}
            leftIcon={<Envelope />}
            onChange={handleChange}
            isError={touched.email && !!errors.email}
            errorLabel={errors.email}
            onBlur={() => setFieldTouched('email')}
          />
          {isNotVerified && (
            <div>
              <p className="error auth__form__description">{t('auth:emailCheckup.notVerified')}</p>
              <p className="auth__form__description">
                {t('auth:emailCheckup.noEmailReceived')}{' '}
                <Link className="link" to="/resend-activation-link">
                  {t('auth:emailCheckup.resendActivation')}
                </Link>
              </p>
            </div>
          )}
          {isNotFound && (
            <div>
              <p className="error auth__form__description">{t('auth:emailCheckup.notFound')}</p>
              <p className="auth__form__description">
                {t('auth:emailCheckup.hasCommunityCode')}{' '}
                <Link
                  className="link"
                  to={{
                    pathname: '/register',
                    state: { email: values.email },
                  }}
                >
                  {t('auth:emailCheckup.selfSignUp')}
                </Link>
              </p>
            </div>
          )}
          {isDeactivated && (
            <p className="auth__form__description error">{t('auth:emailCheckup.deactivated')}</p>
          )}
          <button type="submit" className="button button-primary">
            {t('auth:shared.next')}
          </button>
        </form>
      )}
    </Formik>
  )
}

EmailCheckup.propTypes = {
  setEmail: PropTypes.func,
  setStep: PropTypes.func,
}

export default EmailCheckup
